<script>
export default {
  functional: true,
  props: {
    modifiers: { type: Array, default: () => [] }
  },
  render(h, ctx) {
    const mainClass = 'card__body'
    const modifiedClasses = ctx.props.modifiers.map(
      modifier => `${mainClass}--${modifier}`
    )
    const fullClassList = [mainClass, ...modifiedClasses]

    return h(
      'div',
      {
        ...ctx.data,
        class: fullClassList
      },
      ctx.children
    )
  }
}
</script>
